<template>
  <v-dialog
    :model-value="show"
    @update:model-value="
      {
        if (!state.loading) $emit('update:show', $event);
      }
    "
    max-width="300px"
  >
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between">
        <div>Remove Breaks</div>
        <v-btn
          @click="
            {
              if (!state.loading) $emit('update:show', false);
            }
          "
          icon
          color="transparent"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-item>
        <div class="m-3 d-flex flex-column gap-3 align-center">
          <DatePicker
            style="width: 150px"
            label="Start"
            v-model="state.start"
            type="time"
            :min="dayjs(day.start).subtract(1, 'minutes').toDate()"
            :max="state.end"
            color="primary"
            data-cy="break-bulk-start"
          ></DatePicker>
          <DatePicker
            style="width: 150px"
            label="End"
            v-model="state.end"
            type="time"
            :min="dayjs(state.start).add(1, 'minutes').toDate()"
            :max="
              dayjs(day.end)
                .add(day.time_interval + 1, 'minutes')
                .toDate()
            "
            color="primary"
            data-cy="break-bulk-end"
          ></DatePicker>
        </div>
      </v-card-item>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          variant="flat"
          @click="deleteBreaks"
          :loading="state.loading"
          data-cy="break-bulk-save"
          :disabled="!day?.conference_days_id"
          >Remove</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import type { ConferenceDay } from "@/api_types/teacher";
import DatePicker from "@/components/datePicker.vue";
import FetchService from "@/services/fetch.service";
import { useAlertsStore } from "@/stores/alerts";
import dayjs from "dayjs";
import { watch } from "vue";
import { reactive } from "vue";

const props = defineProps<{ show: boolean; day: ConferenceDay; tab: string }>();
const emit = defineEmits<{
  (event: "update:show", val: boolean): void;
}>();

const state = reactive({
  start: dayjs().set("hours", 8).set("minutes", 0).toDate(),
  end: dayjs().set("hours", 17).set("minutes", 0).toDate(),
  loading: false
});

watch([() => props.day], () => {
  if (!props.day?.start) return;
  const end = dayjs(props.day.end);
  console.log(props.day.start, props.day.end);

  Object.assign(state, {
    start: dayjs(props.day.start).toDate(),
    end: dayjs(props.day.start)
      .set("hours", end.hour())
      .set("minutes", end.minute())
      .set("seconds", end.second())
      .toDate()
  });
});

const deleteBreaks = async () => {
  state.loading = true;
  const start = dayjs(state.start);
  const end = dayjs(state.end);
  const breakRes = await FetchService.fetchData(
    `/conference-days/remove-breaks/${props.day.conference_days_id}?${props.tab}=true`,
    "post",
    {
      break_range: {
        start: dayjs(props.day.start)
          .set("hours", start.hour())
          .set("minutes", start.minute())
          .add(1, "seconds")
          .format(`YYYY-MM-DD HH:mm:ss`),
        end: dayjs(props.day.start)
          .set("hours", end.hour())
          .set("minutes", end.minute())
          .set("seconds", 0)
          .format(`YYYY-MM-DD HH:mm:ss`)
      }
    }
  );

  if (breakRes?.success) {
    useAlertsStore().addAlert("success", "Breaks removed successfully");
    emit("update:show", false);
  } else useAlertsStore().addAlert("error", "Failed to remove breaks, please try again later");
  state.loading = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
</style>
